<template>
  <div>
    <div v-if="selectedRows.length" class="selected-box">
      <el-card class="selected-box__card">
        <strong>Zaznaczone ID:<br /></strong>
        <span v-for="selectedRow in selectedRows" :key="selectedRow.id"
          >{{ selectedRow.id }},
        </span>
      </el-card>
    </div>
    <el-row :gutter="30">
      <el-col :span="6" class="sidebar">
        <router-link v-if="addRoute" :to="addRoute">
          <el-button type="primary" class="fluid">
            Dodaj {{ verboseName }} <i class="el-icon-plus"></i>
          </el-button>
        </router-link>
        <ListFilterComponent
          v-loading="filtersLoading"
          :selected-filters.sync="filters.selected"
          :list-filters="filters.available"
          @filtersChanged="filtersChanged"
        >
        </ListFilterComponent>
      </el-col>
      <el-col class="box" :span="fullWidth ? 24 : 18">
        <div class="list__header">
          <p class="list__title">
            {{ getRouteName($route) }}
          </p>
          <search-list-form
            v-if="includeSearchFilter"
            v-model="filters.selected.search"
            @submit="debouncedFetchData"
          />
        </div>
        <el-row class="header__actions">
          <el-col>
            <component-compiler
              v-for="(component, i) in headerActions()"
              :key="`header-action-${i}`"
              class="margin-right-15"
              :content="component"
            />
          </el-col>
        </el-row>
        <el-table
          ref="table"
          v-loading="listLoading"
          :data="items"
          highlight-current-row
          class="list__table"
          style="width: 100%"
          @sort-change="sortTable"
          @selection-change="handleSelectionChange"
        >
          <el-table-column v-if="allowRowSelection" type="selection" width="55">
          </el-table-column>
          <component
            :is="column.component"
            v-for="(column, i) in columns"
            :key="i"
            :field="column"
          />
          <el-table-column
            v-if="showActions"
            label="akcje"
            width="190"
            class="pull-right"
            class-name="actions"
          >
            <template slot-scope="scope" class="pull-right">
              <component-compiler
                v-for="(component, i) in actions(scope)"
                :key="i"
                :content="component"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24" class="list__pagination">
            <pagination
              layout="prev, pager, next"
              :current-page="page"
              :total-pages="Math.ceil(count / pageSize)"
              @page-change="handlePageChange"
            >
            </pagination>
          </el-col>
        </el-row>
        <el-row>
          <el-row>
            <el-col>
              <component-compiler
                v-for="(component, i) in footerActions()"
                :key="`list-action-${i}`"
                class="margin-right-15"
                :content="component"
              />
            </el-col>
          </el-row>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { clone, debounce, flatten } from 'lodash'
import ListFilterComponent from '@/crudBases/list/ListFilterComponent'
import ImageColumn from './Columns/ImageColumn'
import BooleanColumn from './Columns/BooleanColumn'
import PropColumn from './Columns/PropColumn'
import DatetimeColumn from './Columns/DatetimeColumn'
import ComponentCompiler from '@/components/ComponentCompiler'
import Pagination from '@/components/Pagination'
import FiltersInURLMixin from './FiltersInURLMixin'

export default {
  mixins: [FiltersInURLMixin],
  data() {
    return {
      items: [],
      count: 0,
      page: 1,
      selectedRowsPerPage: {},
      pageSize: 100,
      // fields to override below
      lookupKwargKey: 'id',
      lookupKwargValue: 'id',
      allowRowSelection: false,
      filters: {
        available: [],
        selected: {
          search: ''
        }
      },
      includeSearchFilter: true,
      listLoading: false,
      filtersLoading: false,
      editRouteName: null,
      addRoute: null,
      verboseName: null,
      verboseNamePlural: null,
      listFields: [],
      showActions: true,
      fullWidth: false
    }
  },
  methods: {
    handlePageChange(page) {
      this.page = page
      this.updateQueryParam()
      this.fetchData()
    },
    filtersChanged() {
      if (this.settingInitialParams) {
        return
      }
      this.page = 1
      this.debouncedFetchData()
    },
    debouncedFetchData: debounce(function () {
      this.updateQueryParam()
      this.fetchData()
    }, 300),
    fetchData() {
      let params = {
        page: this.page,
        ...this.filters.selected
      }
      this.listLoading = true
      const rowsToSelect = clone(this.selectedRowsPerPage[this.page])
      this.service
        .fetch({}, { params })
        .then(response => {
          this.count = response.data.count
          this.pageSize = response.data.page_size
          this.items = response.data.results
          if (rowsToSelect) {
            this.$nextTick(() => {
              this.selectRows(rowsToSelect)
            })
          }
          // this.$refs.table.toggleRowSelection(this.items[0])
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$message({
              message: 'Nie masz uprawnien do danych zasobów',
              type: 'error'
            })
          }
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    async handleDelete(index, row) {
      await this.$confirm(
        this.$i18n.t('deleteConfirmation'),
        this.$i18n.t('delete'),
        {
          type: 'warning'
        }
      )

      this.listLoading = true
      try {
        await this.service.delete(this.getDetailsRouteParams(row))
        this.$message({
          message: 'Element został usunięty',
          type: 'success'
        })
      } catch (error) {
        this.$message({
          message: this.getDeleteErrorMessage(error),
          type: 'error'
        })
      }

      this.listLoading = false
      this.fetchData()
    },
    getDeleteErrorMessage(error) {
      const defaultMessage = 'Wystąpił błąd podczas usuwania elementu.'
      const response = error && error.response
      if (!response || !response.data) {
        return defaultMessage
      }

      return (
        this.getErrorMessageFromResponseData(response.data) || defaultMessage
      )
    },
    getErrorMessageFromResponseData(data) {
      if (typeof data === 'string') {
        return data
      }

      if (Array.isArray(data)) {
        return data
          .map(error => this.getErrorMessageFromResponseData(error))
          .join(' ')
      }

      if (typeof data === 'object') {
        if (data.detail) {
          return this.getErrorMessageFromResponseData(data.detail)
        }

        if (data.non_field_errors) {
          return this.getErrorMessageFromResponseData(data.non_field_errors)
        }

        return Object.values(data)
          .map(error => this.getErrorMessageFromResponseData(error))
          .filter(Boolean)
          .join(' ')
      }

      return ''
    },
    handleSelectionChange(val) {
      this.$set(this.selectedRowsPerPage, this.page, val)
    },
    actions(scope) {
      return [
        {
          component: 'router-link',
          attrs: {
            to: this.getEditRoute(scope.row)
          },
          children: [
            this.getButtonComponent({ icon: 'fa fa-edit', title: 'Edytuj' })
          ]
        },
        ...this.additionalActions(scope),
        this.getButtonComponent({
          icon: 'el-icon-delete',
          type: 'danger',
          title: 'Usuń',
          onClick: () => this.handleDelete(scope.$index, scope.row)
        })
      ]
    },
    additionalActions() {
      return []
    },
    getEditRoute(row) {
      return {
        name: this.editRouteName,
        params: this.getDetailsRouteParams(row),
        query: this.$route.query
      }
    },
    getDetailsRouteParams(instance) {
      const params = {}
      params[this.lookupKwargKey] = instance[this.lookupKwargValue]
      return params
    },
    sortTable(params) {
      if (params.prop == null) {
        delete this.filters.selected.ordering
      } else {
        const sign = params.order === 'descending' ? '-' : ''
        this.filters.selected.ordering = `${sign}${params.prop}`
      }
      this.fetchData()
    },
    headerActions() {},
    footerActions() {},
    updateQueryParam() {
      const queryParamsToPush = { ...this.filters.selected, page: this.page }
      this.$router.push({ query: queryParamsToPush })
    },
    selectRows(rows) {
      rows.forEach(row => {
        const rowFromData = this.items.find(item => item.id === row.id)
        this.$refs.table.toggleRowSelection(rowFromData, true)
      })
    }
  },
  components: {
    Pagination,
    ListFilterComponent,
    ImageColumn,
    BooleanColumn,
    PropColumn,
    DatetimeColumn,
    ComponentCompiler
  },
  computed: {
    service() {
      return null
    },
    columns() {
      const components = {
        image: 'ImageColumn',
        boolean: 'BooleanColumn',
        datetime: 'DatetimeColumn'
      }
      return this.listFields.map(field => ({
        ...field,
        component: components[field.type] || 'PropColumn'
      }))
    },
    selectedRows() {
      return flatten(Object.values(this.selectedRowsPerPage))
    }
  },
  watch: {
    'filters.selected': {
      deep: true,
      handler() {
        this.filtersChanged()
      }
    }
  },
  mounted() {
    this.fetchData()
    if (this.service.logListViewed !== undefined) {
      this.service.logListViewed()
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .footer-action {
  margin-right: 15px;
}

::v-deep .header-action {
  margin-right: 15px;
}

.header__actions {
  margin-top: -30px;
  margin-bottom: 30px;
}

::v-deep .actions .cell {
  display: flex;
  flex-wrap: wrap;
}

.selected-box {
  position: fixed;
  z-index: 1;
  bottom: 20px;
  left: 246px;

  &__card {
    max-width: 400px;
    border-left: 7px solid #2f4050;
  }
}

::v-deep a + .el-button {
  margin-left: 10px;
}
</style>
